<template>
  <div :class="'print-btn ' + (this.sendingDataToPrinter ? 'print-btn--sending' : '')">
    <m4-toast v-if="toastMessage" :delay="5">
      {{ toastMessage }}
    </m4-toast>
    <m4-button @click="submit" left-icon="print" v-bind="$attrs">
      <slot></slot>
    </m4-button>
    <div class="print-btn__setting">
      <m4-dialog
        title="Available printers"
        btn-title="Save"
        @openModal="getPrinterList"
        @onSubmitDialogAndClose="savePrinter"
      >
        <template v-slot:button>
          <m4-icon icon="cog" ref="cog_icon"></m4-icon>
        </template>
        <m4-loader v-if="loadingAvailablePrinters" :width="4" class="text-center"></m4-loader>
        <m4-form-field v-else type="select" @input="setCurrPrinterValue" :value="getPrinter()">
          <option value="">- choose one -</option>
          <option v-for="printer in availablePrinters" :key="printer" :value="printer">{{ printer }}</option>
        </m4-form-field>
      </m4-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4PrintButton",
  data() {
    return {
      toastMessage: null,
      currPrinter: null,
      availablePrinters: null,
      loadingAvailablePrinters: false,
      sendingDataToPrinter: false
    };
  },
  props: {
    name: String,
    pdfLink: String,
    printUrl: {
      type: String,
      default() {
        return "http://localhost:7000/print/from-pdf";
      }
    },
    printerListUrl: {
      type: String,
      default() {
        return "http://localhost:7000/printers/list";
      }
    }
  },
  methods: {
    setCurrPrinterValue(val) {
      this.currPrinter = val;
    },
    savePrinter() {
      localStorage.setItem(this.name + "_print_btn", this.currPrinter);
    },
    getPrinter() {
      let val = localStorage.getItem(this.name + "_print_btn");
      if (val) {
        return val;
      }
      return this.currPrinter;
    },
    getPrinterList() {
      this.loadingAvailablePrinters = true;
      window
        .axios({
          method: "get",
          url: this.printerListUrl,
          responseType: "json"
        })
        .then((response) => {
          if (response.data !== undefined && response.data.length > 0) {
            this.availablePrinters = response.data;
          } else {
            alert("No available printers");
          }
          this.loadingAvailablePrinters = false;
        })
        .catch((Error) => {
          this.loadingAvailablePrinters = false;
          if (Error.response != undefined && Error.response.data != undefined) {
            alert(Error.response.data.errors[0].details);
          } else {
            alert(Error);
          }
        });
    },
    submit() {
      if (this.sendingDataToPrinter) {
        return;
      }

      this.toastMessage = null;

      if (this.getPrinter()) {
        this.sendingDataToPrinter = true;
        window
          .axios({
            method: "get",
            url: this.pdfLink,
            responseType: "blob"
          })
          .then((response) => {
            this.printIt(response.data);
          })
          .catch((Error) => {
            if (Error.response != undefined && Error.response.data != undefined) {
              alert(Error.response.data.errors[0].details);
            } else {
              alert(Error);
            }
          });
      } else {
        this.$refs.cog_icon.$el.click();
      }
    },
    printIt(pdfBlob) {
      let formData = new FormData();
      formData.append("PrinterPath", this.getPrinter());
      formData.append("PdfFile", pdfBlob, "test.pdf");

      let message = "The data has been sent to the printer";

      setTimeout(() => {
        this.sendingDataToPrinter = false;
      }, 1000);

      window.axios
        .post(this.printUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          this.toastMessage = message;
        })
        .catch(() => {
          this.toastMessage = message;
        });
    }
  }
};
</script>
